const HomeIcon: FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        strokeWidth="1.33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.30347 13V21C4.30347 23.2091 6.09433 25 8.30347 25H17.4463C19.6555 25 21.4463 23.2091 21.4463 21V13"
            strokeLinecap="round"
        />
        <path d="M0.875 10.75L12.875 1L24.875 10.75" strokeLinecap="round" />
    </svg>
);

export default HomeIcon;
